import { Grid } from "antd";

const { useBreakpoint } = Grid;

export default useBreakpoint;
